import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SetupService } from '@core/services/setup';
import { HomeService } from './home.service';
import { UserService } from '../user/user.service';
import { LocalStorage } from '@core/localstorage';
import { WINDOW } from '@core/http/window.providers';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy {
    loggedIn: boolean;
    private freshworksScriptId = 'freshworks-widget-script';

    constructor(
        private title: Title,
        public setupService: SetupService,
        public homeService: HomeService,
        private userService: UserService,
        private localStorage: LocalStorage,
        @Inject(WINDOW) private window: Window
    ) {
        this.title.setTitle(this.setupService.title);
    }

    ngOnInit(): void {
        // this.changeHeroBasedOnScreenSize();
        this.userService.currentUser.subscribe((user) => {
            this.loggedIn = Boolean(user);
        });
        this.initFreshworksWidget();
    }

    isCbt() {
        return (
            this.localStorage.getHost().includes('cbt.tenisintegrado.com.br') ||
            this.localStorage.getHost().includes('cbt.esp.br') ||
            this.localStorage.getHost().includes('cbt-tenis.com.br') ||
            this.localStorage.getHost().includes('cbtenis.com.br')
        );
    }

    initFreshworksWidget(): void {
        if (!document.getElementById(this.freshworksScriptId)) {
            const host = this.localStorage.getHost();
            if (host?.includes('fpt.tenisintegrado.com.br')) {
                (this.window as any).fwSettings = {
                    widget_id: 13000000706,
                };
                if (typeof (this.window as any).FreshworksWidget !== 'function') {
                    const n = function () {
                        n.q.push(arguments);
                    };
                    n.q = [];
                    (this.window as any).FreshworksWidget = n;
                }
                const script = document.createElement('script');
                script.id = this.freshworksScriptId;
                script.type = 'text/javascript';
                script.src = 'https://widget.freshworks.com/widgets/13000000706.js';
                script.async = true;
                script.defer = true;
                document.head.appendChild(script);
            }
        }
    }

    ngOnDestroy(): void {
        const script = document.getElementById(this.freshworksScriptId);
        if (script) {
            script.remove();
        }
    }
}
